<template lang="pug">
    #effect-widget-app.effect-widget-app()
        c-widget(v-if="rootShow")
</template>

<script>
import { designApp, login, yandexMetrika } from '@/mixins/mixins'
import socket from '@/mixins/socket'
import pollingSockets from '@/mixins/pollingSockets'

import lodash_isEmpty from 'lodash/isEmpty'

import config from '@/config/index'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import axios from 'axios'

export default {
    name: 'app',
    components: {
        CWidget: () => import('@/components/CWidget.vue')
    },
    mixins: [yandexMetrika, login, socket, designApp, pollingSockets],
    data() {
        return {
            show: true,
            uuid: null,
            uuids: {},
            initialized: false
        }
    },
    watch: {
        '$store.state.api'(val) {
            //console.log('$stote.state.api', val)
        }
    },
    computed: {
        rootShow() {
            return this.$store.state.api.loading
        }
    },
    created() {
        this.$root.$on('triggerEvent', this.emitTriggerEvent)
        this.$root.$emit('triggerEvent', 'effectReady')
        if (
            (!this.$store.state.localStorage.initStart || !this.$store.state.active_chat_id) &&
            config.siteOptions.common.lazy_init === 1
        ) {
            this.$store.commit('setChatActive', false) // при режиме отложенной (VUE_APP_ENABLELAZYINIT=1), после завершения диалога делаем initStart=false, после обновления chatActive оставался true по этому чат не запускался при выволнении функции window.effectWidgetSetOptions({ showChat: true })
            this.$root.$emit('triggerEvent', 'effectChatClose')

            this.$root.$once('effectReadyBeforeInit', () => {
                //this.$root.$emit('triggerEvent', 'effectReady')
            })
            this.$root.$once('setInitStarted', () => {
                this.$store.commit('setLocalStorage', ['initStart', true])
            })
        }

        this.$root.$once('initPointOnce', () => {
            if (
                !this.$store.state.localStorage.initStart &&
                config.siteOptions.common.lazy_init === 1
            ) {
                this.$root.$emit('setInitStarted')
                this.initPoint()
            }
        })

        window.addEventListener('unhandledrejection', this.promiseErrorHandler)
        window.addEventListener('storage', this.storageEventHandler, false)
        this.$root.$on('initPoint', this.initPoint)

        this.uuid = this.getCookie('effect-uuid') || this.$store.state.localStorage.uuid
        this.uuids = this.getCookie('effect-uuids') || this.$store.state.localStorage.uuids
        if (typeof this.uuids === 'string' || this.uuids instanceof String) {
            this.uuids = JSON.parse(decodeURIComponent(this.uuids))
        }

        const refreshAuthLogic = failedRequest =>
            this.login(false).then(response => {
                let data = failedRequest.response.config.data
                data = JSON.parse(data)
                data.authGuestData = response
                failedRequest.response.config.data = data
                return Promise.resolve()
            })
        createAuthRefreshInterceptor(axios, refreshAuthLogic, {})

        this.initPoint()

        this.$root.$on('setDialogActive', this.emitSetDialogActive)
        this.$root.$on('setChatActive', this.emitSetChatActive)
        this.$root.$on('setMenuActive', this.emitSetMenuActive)

        this.$root.$on('operatorAction', this.emitOperatorAction)

        this.$store.commit('setChatActive', false)
    },
    beforeDestroy() {
        this.$root.$off('setDialogActive', this.emitSetDialogActive)
        this.$root.$off('setChatActive', this.emitSetChatActive)
        this.$root.$off('setMenuActive', this.emitSetMenuActive)

        this.$root.$off('operatorAction', this.emitOperatorAction)
        this.$root.$off('initPoint', this.initPoint)
    },
    beforeCreate() {
        window.removeEventListener('unhandledrejection', this.promiseErrorHandler)
        window.removeEventListener('storage', this.storageEventHandler)
        this.$root.$off('triggerEvent', this.emitTriggerEvent)
        window.removeEventListener('hashchange', this.hashchange)
    },

    methods: {
        hashchange() {
            this.initPoint()
        },
        initPoint() {
            if (
                (!this.$store.state.localStorage.initStart ||
                    (!this.$store.state.active_chat_id && !this.$store.state.chatActive)) &&
                config.siteOptions.common.lazy_init === 1
            )
                return

            if (config.siteOptions.common.login) {
                this.login()
            } else {
                this.init()
            }
        },
        getCookie(name) {
            const nameEQ = name + '='
            const ca = document.cookie.split(';')
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i]
                while (c.charAt(0) === ' ') c = c.substring(1, c.length)
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
            }
            return null
        },
        emitOperatorAction() {
            this.$root.$emit('soundNewMessage')
            this.$root.$emit('setChatActive', true)
        },
        emitSetMenuActive(val) {
            this.$store.commit('setMenuActive', val)
        },

        emitSetDialogActive(dialogName) {
            this.$store.commit('setDialogActive', dialogName)
        },
        emitSetChatActive(val) {
            if (this.$store.state.chatActive === val) return

            if (val) {
                this.$root.$emit('initPointOnce')

                this.$root.$emit('triggerEvent', 'effectChatOpen')

                this.$root.$emit('scrollbarScrollerChatPush')

                setTimeout(() => {
                    this.$root.$emit('setTextAreaFocus')
                }, 500)
            } else {
                this.$root.$emit('triggerEvent', 'effectChatClose')
                this.$store.commit('scenario/setOperationId', null)
                this.$store.commit('scenario/setBoxHelloText', null)
            }

            this.$store.commit('setChatActive', val)
        },

        emitSetAction(val) {
            this.$store.commit('chat/messageAction', val)
        },

        emitTriggerEvent(name) {
            const event = new CustomEvent(name)
            document.dispatchEvent(event)
        },
        promiseErrorHandler(event) {
            console.log(
                'Unhandled rejection (promise: ',
                event.promise,
                ', reason: ',
                event.reason,
                ')'
            )
        },
        storageEventHandler(e) {},

        init(socketPayload = {}) {
            if (
                !this.$store.state.localStorage.initStart &&
                config.siteOptions.common.lazy_init === 1 &&
                lodash_isEmpty(socketPayload)
            )
                return

            if (
                config.siteOptions.common.lazy_init === 1 &&
                !this.$store.state.active_chat_id &&
                !this.$store.state.chatActive
            )
                return

            let params = {}

            this.$store.commit('setSessionStorageBrowsedPages')

            params = {
                session_start: this.$store.state.sessionStorage.session_start,
                browsed_pages_count: this.$store.state.sessionStorage.browsed_pages.length,
                guest_referrer: document.referrer,
                title: document.title,
                uuid: this.uuid,
                uuids: this.uuids,
                ...socketPayload,
                activeChatId: this.$store.state.active_chat_id
            }

            this.$root.$emit('effectReadyBeforeInit')
            this.$store.commit('setLoader', true)

            return this.$store.dispatch('init', params).then(() => {
                if (this.$store.state.active_chat_id && this.$store.state.chatActive) {
                    this.$root.$emit('triggerEvent', 'effectChatStarted')
                }
                window.addEventListener('hashchange', this.hashchange)
                //Включаем поллинг для сокетов
                this.$root.$emit('emitPollingSockets')
                if (
                    (lodash_isEmpty(socketPayload) ||
                        (socketPayload.reason &&
                            socketPayload.reason === 'login_timeout' &&
                            this.$store.state.api.guest_changed)) &&
                    (this.$store.state.lastChatId || this.$store.state.authGuestData) &&
                    !this.initialized
                ) {
                    setTimeout(() => {
                        this.$root.$emit_p('resetHistory').then(res => {
                            if (res) {
                                this.$root.$emit('scenarioInitOnce')
                            }
                        })
                    }, 1000)
                }
                this.initialized = true
            })
        }
    }
}
</script>

<style lang="scss">
//@import "@/scss/vendors/cleanslate.scss";
:root {
    @each $i, $c in $cssVarsMain {
        #{$prefix-var}#{$i}: #{$c};
    }
    @each $i, $c in $glob-colors {
        #{$prefix-var}color-#{$i}: #{$c};
    }
}
.effect-widget-app {
    //@extend %cleanslate;

    display: glob-vars('show');

    &,
    & *,
    *::after,
    *::before {
        @extend %initials-all;
        @extend %initials-inherited;
        box-sizing: inherit;

        color: inherit;
        font-size: inherit;
        font-family: inherit;
        font-weight: inherit;
        font-style: inherit;
        text-decoration: inherit;
        cursor: inherit;
        text-align: inherit;
    }
    & *,
    *,
    & *,
    *::after,
    & *,
    *::before {
        box-sizing: inherit;
    }
    & *,
    * {
        -webkit-tap-highlight-color: transparent;
        &:focus {
            outline: none;
        }
    }
    .ps-container {
        position: relative;
        overflow: hidden;
    }
    form,
    .ps-container {
        display: block;
    }

    a,
    a:hover {
        border-color: inherit;
        color: inherit;
        cursor: pointer;
    }

    & {
        font-size: $glob-font-size_main-wrap;
    }
}
</style>
